function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null
  return value as Record<string, unknown>
}

function asString(value: unknown): string | null {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function extractRuntimeClientMessageId(args: {
  value: unknown
}): string | undefined {
  const root = asRecord(args.value)
  if (!root) return undefined

  const candidateRecords = [
    root,
    asRecord(root.metadata),
    asRecord(root.info),
    asRecord(root.message),
    asRecord(root.source),
    asRecord(root.content),
  ]

  for (const record of candidateRecords) {
    const clientMessageId = asString(record?.clientMessageId) ?? asString(record?.client_message_id)
    if (clientMessageId) {
      return clientMessageId
    }
  }

  return undefined
}
